import React, { useEffect } from 'react';
import styles from './thirdPartyQuestionnarie.module.css';
import ThirdPartyContentOuterLayer
    from "../../Components/ThirdPartyQuestionnaire/thirdPartyContentOuterLayer/thirdPartyContentOuterLayer";

const ThirdPartyQuestionnaire = () => {
    useEffect(() => {
        document.documentElement.style.scrollBehavior = 'smooth';

        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            event.preventDefault();
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            document.documentElement.style.scrollBehavior = 'auto';
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    return (
            <div className={styles.third_party_questionnarie_outer_div}>
                <ThirdPartyContentOuterLayer />
            </div>

    )
};

export default ThirdPartyQuestionnaire;